import { render } from "./BugReportCard.vue?vue&type=template&id=2734a7a4&scoped=true"
import script from "./BugReportCard.vue?vue&type=script&lang=js"
export * from "./BugReportCard.vue?vue&type=script&lang=js"

import "./BugReportCard.vue?vue&type=style&index=0&id=2734a7a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2734a7a4"

export default script